const getTotal = (orderDetails) => {
	return orderDetails.reduce((sum, { price }) => sum + price, 0);
};

export default getTotal;
